var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"m-icon-stroke-color",attrs:{"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3 7L6 4L3 1","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }